import { useLocation } from "react-router-dom"

export default function NotFound() {
    const location = useLocation();

    return <p className="text-center mt-4">Page not Found<br /><br /><small>{location.pathname}</small></p>
}